import { useContext } from 'react';
import { ThemeContext } from '../context/ThemeContext';

export function useTheme() {
    const context = useContext(ThemeContext);
    if (context === undefined) {
        throw new Error('useTheme must be used within a ThemeProvider');
    }
    return [context.theme, context.setTheme, context.isDarkMode] as const;
}
